export default __webpack_public_path__ + "static/avatar-kortical-team3-225dbb59fdec81776d8e54203cb89942.jpg";